import type { FC } from 'react';

import type { IconProps } from './BaseIcon';
import { BaseIcon } from './BaseIcon';

export const RealTimeConfigurationIcon: FC<IconProps> = ({ ...props }) => (
  <BaseIcon {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.1543 17.0039C14.3931 17.0667 15.4336 17.881 15.8291 19H23C23.5523 19 24 19.4477 24 20C24 20.5523 23.5523 21 23 21H15.8252C15.4293 22.1184 14.3927 22.9334 13.1543 22.9961L13 23C11.688 23 10.5735 22.1576 10.166 20.9844C10.1119 20.9934 10.0567 21 10 21H9C8.44772 21 8 20.5523 8 20C8 19.4477 8.44772 19 9 19H10C10.0573 19 10.1133 19.0054 10.168 19.0146C10.5759 17.8422 11.6886 17 13 17L13.1543 17.0039ZM13 19C12.4477 19 12 19.4477 12 20C12 20.5523 12.4477 21 13 21C13.5177 21 13.9438 20.6067 13.9951 20.1025L14 20L13.9951 19.8975C13.9438 19.3933 13.5177 19 13 19Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.1543 9.00391C20.3985 9.06694 21.4424 9.88815 21.834 11.0146C21.888 11.0056 21.9434 11 22 11H23C23.5523 11 24 11.4477 24 12C24 12.5523 23.5523 13 23 13H22C21.942 13 21.8854 12.9939 21.8301 12.9844C21.4384 14.1107 20.3984 14.9331 19.1543 14.9961L19 15C17.688 15 16.5735 14.1576 16.166 12.9844C16.1119 12.9934 16.0567 13 16 13H9C8.44772 13 8 12.5523 8 12C8 11.4477 8.44772 11 9 11H16C16.0573 11 16.1133 11.0054 16.168 11.0146C16.5759 9.8422 17.6886 9 19 9L19.1543 9.00391ZM19 11C18.4477 11 18 11.4477 18 12C18 12.5523 18.4477 13 19 13C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M26.2041 4.01074C27.2128 4.113 28 4.96435 28 6V26L27.9893 26.2041C27.8938 27.1457 27.1457 27.8938 26.2041 27.9893L26 28H6L5.7959 27.9893C4.85435 27.8938 4.1062 27.1457 4.01074 26.2041L4 26V6C4 4.96435 4.78722 4.113 5.7959 4.01074L6 4H26L26.2041 4.01074ZM6 26H26V6H6V26Z"
    />
  </BaseIcon>
);
